const cardItems = [
  {
    title: '2026暑期档必看指南',
    desc: '院线大片、流媒体新片一网打尽，这个夏天不容错过的十部佳作全收录。',
    tag: '观影指南',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20blockbuster%20movie%20poster%20style%20with%20warm%20sunset%20lighting%2C%20dramatic%20silhouette%2C%20golden%20hour%20tones%2C%20film%20noir%20aesthetic%2C%20professional%20composition%2C%20rich%20contrast%20minimal%20design&width=600&height=800&seq=card-poster-01-v2&orientation=portrait',
    imgAlt: '暑期档观影指南',
  },
  {
    title: '悬疑烧脑片单：全程高能无尿点',
    desc: '从经典推理到现代惊悚，精选15部让你猜不到结局的高分悬疑力作。',
    tag: '精选片单',
    img: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%20style%20with%20dark%20moody%20lighting%2C%20mysterious%20shadow%20figure%2C%20high%20contrast%20noir%20aesthetic%2C%20deep%20amber%20and%20crimson%20tones%2C%20professional%20cinematography%2C%20minimal%20design&width=600&height=800&seq=card-poster-02-v2&orientation=portrait',
    imgAlt: '悬疑烧脑片单',
  },
  {
    title: '治愈系日剧：温暖你的一周',
    desc: '美食、日常、小确幸，这份日剧片单让每个疲惫的夜晚都有温柔的陪伴。',
    tag: '日剧专题',
    img: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20Japanese%20drama%20movie%20poster%20style%20with%20soft%20natural%20lighting%2C%20cherry%20blossom%20aesthetic%2C%20tender%20golden%20hour%20tones%2C%20minimal%20composition%2C%20healing%20atmosphere%2C%20professional%20photography&width=600&height=800&seq=card-poster-03-v2&orientation=portrait',
    imgAlt: '治愈系日剧专题',
  },
  {
    title: '国产动画崛起：这些作品封神了',
    desc: '从大圣到哪吒再到深海，盘点国产动画电影的技术飞跃与艺术突破之路。',
    tag: '动画专题',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20film%20poster%20style%20with%20epic%20fantasy%20elements%2C%20vibrant%20warm%20colors%2C%20mythological%20motifs%2C%20cinematic%20lighting%2C%20dynamic%20composition%2C%20professional%20art%20direction%2C%20rich%20textures&width=600&height=800&seq=card-poster-04-v2&orientation=portrait',
    imgAlt: '国产动画崛起专题',
  },
  {
    title: '奥斯卡历年最佳影片全回顾',
    desc: '从1929到2026，跨越近百年的奥斯卡最佳影片，每一部都值得反复品味。',
    tag: '经典回顾',
    img: 'https://readdy.ai/api/search-image?query=Classic%20Hollywood%20film%20poster%20style%20with%20golden%20statue%20trophy%2C%20vintage%20warm%20lighting%2C%20elegant%20old%20cinema%20aesthetic%2C%20rich%20golden%20and%20dark%20tones%2C%20prestigious%20award%20atmosphere%2C%20professional%20photography&width=600&height=800&seq=card-poster-05-v2&orientation=portrait',
    imgAlt: '奥斯卡最佳影片回顾',
  },
  {
    title: '韩剧年度口碑榜：部部9分+',
    desc: '从悬疑犯罪到浪漫喜剧，2026年度韩剧口碑巅峰之作，评分说话不踩雷。',
    tag: '韩剧榜单',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20film%20poster%20style%20with%20modern%20urban%20aesthetic%2C%20warm%20romantic%20lighting%2C%20cinematic%20composition%2C%20soft%20color%20grading%2C%20professional%20photography%2C%20elegant%20minimal%20design%2C%20emotional%20mood&width=600&height=800&seq=card-poster-06-v2&orientation=portrait',
    imgAlt: '韩剧年度口碑榜',
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="bg-background-50 py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-800 whitespace-nowrap mb-3">
            专题策划
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            精选影视专题
          </h2>
          <p className="text-foreground-600 text-sm mt-2">精心策划的电影电视剧专题合集，发现更多好内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-lg overflow-hidden border border-background-200/70 group cursor-pointer"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.imgAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 text-xs font-medium rounded bg-primary-500/85 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}